<div class="card ">
  <div class="card-header">
    <h5 class="card-title">
      <!-- <i class="fas fa-clock me-2"></i> -->
      Tarifa por Horas
    </h5>
    <h6 class="card-subtitle text-muted">Configura el precio por tiempo de uso</h6>
  </div>
  <div class="card-body">
    <form>
      <!-- Selector de tipo de tarifa -->
      <div class="hourly-rate-selector mt-3">
        <div class="hourly-rate-option"
             [class.hourly-rate-option--active]="selectedDuration === 'half'"
             (click)="selectDuration('half')">
          <i class="fas fa-clock"></i>
          30 min
        </div>
        <div class="hourly-rate-option"
             [class.hourly-rate-option--active]="selectedDuration === 'oneHalf'"
             (click)="selectDuration('oneHalf')">
          <i class="fas fa-clock"></i>
          1h
        </div>
        <div class="hourly-rate-option"
             [class.hourly-rate-option--active]="selectedDuration === 'two'"
             (click)="selectDuration('two')">
          <i class="fas fa-clock"></i>
          2h
        </div>
        <div class="hourly-rate-option"
             [class.hourly-rate-option--active]="selectedDuration === 'custom'"
             (click)="selectDuration('custom')">
          <i class="fas fa-cog"></i>
          personalizada
        </div>
      </div>

      <!-- Descripción del tipo seleccionado -->
      <div class="info-banner mt-4" [class.info-banner--custom]="selectedDuration == 'custom'">
        <div class="d-flex gap-3 align-items-start">
          <i class="fas fa-info-circle fs-4"></i>
          <div class="flex-fill">
            <span *ngIf="selectedDuration == 'half'">
              <strong>Media hora:</strong> Cobro automático cada 30 minutos de uso
            </span>
            <span *ngIf="selectedDuration == 'oneHalf'">
              <strong>Hora y media:</strong> Perfecto para sesiones de juego estándar (60 minutos)
            </span>
            <span *ngIf="selectedDuration == 'two'">
              <strong>Dos horas:</strong> Ideal para partidos completos o entrenamientos largos
            </span>
            <span *ngIf="selectedDuration == 'custom'">
              <strong>Duración personalizada:</strong> Define tu propio periodo de cobro según tus necesidades
            </span>
          </div>
        </div>
      </div>

      <!-- Configuración de tarifa -->
      <div class=" mt-4 p-2">
        <div class="form p-4">
          <div class="mb-4 pb-3 border-bottom border-2">
            <h6 class="fs-5 fw-semibold text-dark m-0 d-flex align-items-center gap-2">
              <span class="d-inline-flex align-items-center justify-content-center bg-primary text-white rounded-2"
                    style="width: 35px; height: 35px; font-size: 1.2rem; font-weight: bold;">€</span>
              Configuración de Precio
            </h6>
          </div>

          <!-- Duración personalizada (solo si es custom) -->
          <div class="mb-4" *ngIf="selectedDuration == 'custom'">
            <label class="form-label fw-semibold text-secondary mb-2">
              <i class="fas fa-hourglass-half me-2"></i>
              Duración
            </label>
            <div class="row">
              <div class="col-md-6">
                <div class="d-flex">
                  <input
                    type="number"
                    step="1"
                    min="0"
                    max="23"
                    class="form-control form-control-group"
                    [(ngModel)]="customHours"
                    name="customHours"
                    placeholder="0">
                  <div class="input_right_data">horas</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex">
                  <input
                    type="number"
                    step="15"
                    min="0"
                    max="45"
                    class="form-control form-control-group"
                    [(ngModel)]="customMinutes"
                    name="customMinutes"
                    placeholder="0">
                  <div class="input_right_data">minutos</div>
                </div>
              </div>
            </div>
            <small class="form-text text-muted d-block mt-2">Define la duración del periodo de cobro (ej: 2h 30min)</small>
          </div>

          <!-- Precio por uso -->
          <div class="mb-4">
            <label class="form-label fw-semibold text-secondary mb-2">
              <i class="fas fa-euro-sign me-2"></i>
              Precio por Periodo
            </label>
            <div class="d-flex">
              <input
                type="number"
                step="0.01"
                min="0"
                class="form-control form-control-group"
                [(ngModel)]="price"
                name="price"
                placeholder="0.00">
              <div class="input_right_data">€</div>
            </div>
            <small class="form-text text-muted d-block mt-2">Precio que se cobrará por cada periodo de uso</small>
          </div>

          <!-- Resumen visual -->
          <div class="card border-primary border-5 mt-4 p-2">
            <div class="card-header bg-white border-bottom border-primary border-2">
              <h6 class="fs-4 fw-semibold text-dark m-0 d-flex align-items-center gap-2">
                <i class="fas fa-calculator text-primary"></i>
                Resumen de Precio
              </h6>
            </div>
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center py-3 border-bottom">
                <span class="text-secondary fw-medium">Duración:</span>
                <span class="fs-6 fw-semibold text-dark">
                  <strong>{{ getTotalDurationDisplay() }}</strong>
                </span>
              </div>
              <div class="d-flex justify-content-between align-items-center py-3 border-bottom">
                <span class="text-secondary fw-medium">Precio por periodo:</span>
                <span class="fs-2 fw-bold " style="color: #2e8eaa;">
                  <strong>{{ price || 0 }}€</strong>
                </span>
              </div>
              <div class="d-flex justify-content-between align-items-center py-3">
                <span class="text-secondary fw-medium">Equivalente por hora:</span>
                <span class="fs-6 fw-semibold text-dark">
                  {{ getPricePerHour() }}€/h
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botones de acción -->
      <div class="form-group row mt-5">
        <div class="col-sm-8 ms-sm-auto">
          <button type="button" class="btn btn-primary" (click)="save()">
            {{ "overwrite" | translate }}
          </button>
          <button type="button" class="btn btn-light ms-2" (click)="cancel()">
            {{ "restore" | translate }}
          </button>
        </div>
      </div>
    </form>

    <!-- Mensajes de error y éxito -->
    <div class="alert alert-danger alert-dismissible mt-3" role="alert" *ngIf="error != ''">
      <div class="alert-message">
        <i class="fas fa-exclamation-triangle me-2"></i>
        {{ error }}
      </div>
    </div>
    <div class="alert alert-success alert-dismissible mt-3" role="alert" *ngIf="successMessage">
      <div class="alert-message">
        <i class="fas fa-check-circle me-2"></i>
        {{ "updatedSuccesfully" | translate }}
      </div>
    </div>
  </div>
</div>
